import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from './user.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private user: UserService, private router: Router) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!!this.user.currentUser && !!this.user.currentUser.wmid) {
      return true;
    } else {
      return this.user.login();
    }
  }
}

@Injectable()
export class AdminAuthGuard implements CanActivate {
  constructor(private user: UserService, private router: Router) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!!this.user.currentUser && !!this.user.currentUser.wmid && this.user.currentUser['role'] === 'admin') {
      return true;
    } else {
      window.location.href = '/';
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/auth.guard.ts